import { useEffect, useState } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { SplashScreen } from './modules/desktop/SplashScreen'
import DbSetupWizard from './modules/desktop/DbSetupWizard'
import CloseConfirm from './modules/desktop/CloseConfirm'

const isTauri = typeof window !== 'undefined' && !!(window as { __TAURI__?: unknown }).__TAURI__

export default function App() {
  if (!isTauri) return <RouterProvider router={router} />
  return <DesktopApp />
}

// Masaüstü (Tauri) açılış akışı:
// - İstemci rolü → sunucu adresini ayarla, doğrudan uygulamaya geç.
// - Sunucu, DB kurulmamış → DbSetupWizard (postgres şifresi → DB+şema+seed).
// - Sunucu, DB kurulu → SplashScreen API hazır olana kadar bekler.
function DesktopApp() {
  const [phase, setPhase] = useState<'init' | 'setup' | 'splash' | 'ready'>('init')

  useEffect(() => {
    let alive = true
    ;(async () => {
      let base = 'http://localhost:3001/api/v1'
      let next: 'setup' | 'splash' | 'ready' = 'splash'
      try {
        const { invoke } = await import('@tauri-apps/api/core')
        const cfg = await invoke<{ role?: string; server_url?: string; api_port?: number; db_setup_done?: boolean }>('get_config')
        if (cfg?.role === 'client' && cfg.server_url) {
          base = cfg.server_url
          next = 'ready'
        } else {
          base = `http://localhost:${cfg?.api_port ?? 3001}/api/v1`
          next = cfg?.db_setup_done ? 'splash' : 'setup'
        }
      } catch {
        /* config okunamazsa varsayılan localhost:3001 (sunucu) */
      }
      localStorage.setItem('inova-api-base', base)
      // Masaüstünde kök rota (landing) yerine doğrudan giriş ekranı
      if (window.location.pathname === '/') window.history.replaceState(null, '', '/login')
      if (!alive) return
      setPhase(next)
    })()
    return () => { alive = false }
  }, [])

  return (
    <>
      {/* Çarpı (kapat) onay dialog'u — her fazda dinlemede olsun */}
      <CloseConfirm />
      {phase === 'init' ? null
        : phase === 'setup' ? <DbSetupWizard onDone={() => setPhase('splash')} />
        : phase === 'splash' ? <SplashScreen onReady={() => setPhase('ready')} />
        : <RouterProvider router={router} />}
    </>
  )
}
